/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Answer_RequiredInputs */

const en_us2_profile_editors_pain_answer_required = /** @type {(inputs: Profile_Editors_Pain_Answer_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer this question.`)
};

const pt_br2_profile_editors_pain_answer_required = /** @type {(inputs: Profile_Editors_Pain_Answer_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responda esta pergunta.`)
};

const es_419_profile_editors_pain_answer_required = /** @type {(inputs: Profile_Editors_Pain_Answer_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde esta pregunta.`)
};

const pt_pt2_profile_editors_pain_answer_required = /** @type {(inputs: Profile_Editors_Pain_Answer_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responde a esta pergunta.`)
};

const fr_fr2_profile_editors_pain_answer_required = /** @type {(inputs: Profile_Editors_Pain_Answer_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponds à cette question.`)
};

const de_de2_profile_editors_pain_answer_required = /** @type {(inputs: Profile_Editors_Pain_Answer_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantworte diese Frage.`)
};

const it_it2_profile_editors_pain_answer_required = /** @type {(inputs: Profile_Editors_Pain_Answer_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rispondi a questa domanda.`)
};

/**
* | output |
* | --- |
* | "Answer this question." |
*
* @param {Profile_Editors_Pain_Answer_RequiredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_answer_required = /** @type {((inputs?: Profile_Editors_Pain_Answer_RequiredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Answer_RequiredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_answer_required(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_answer_required(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_answer_required(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_answer_required(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_answer_required(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_answer_required(inputs)
	return en_us2_profile_editors_pain_answer_required(inputs)
});
export { profile_editors_pain_answer_required as "profile-editors.pain_answer_required" }